import styled from 'styled-components';

export const StyledP = styled.p`
    font-size: 0.875rem;
    line-height: 6px;
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.03em;
    color: ${({ theme }) => theme.shades.white[50]};
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin-left: 10px;
        color: ${({ theme }) => theme.colors.white[50]};
    }
`;
